const getters = {
  Token: (state) => state.user.token,
  UserInfo: (state) => state.user.user_info,
  global_loading: (state) => state.antai.loading,
  page_loading: (state) => state.antai.page_loadding,
  global_user_info: (state) => state.antai.user_info, //全局用户信息
};

export default getters;
